import { Overlay } from '@angular/cdk/overlay';
import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { provideDialogConfig } from 'ng-primitives/dialog';

export function provideDialog(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: provideDialogConfig,
      useFactory: (overlay: Overlay) =>
        provideDialogConfig({
          role: 'dialog',
          modal: true,
          closeOnEscape: false,
          closeOnClick: false,
          closeOnNavigation: true,
          scrollStrategy: overlay.scrollStrategies.block(),
        }),
      deps: [Overlay],
    },
  ]);
}
